import React from 'react';
import { Section } from './Section';
import { X } from 'lucide-react';
export const IntentosFallidos = () => {
  const fallos = [{
    title: "Tomar café para 'aguantar'",
    desc: 'Solo altera más tu sistema nervioso y rompe tu escudo natural.'
  }, {
    title: 'Quejarte del trabajo al llegar a casa',
    desc: 'Solo reactiva la conexión energética con el problema.'
  }, {
    title: 'Las vacaciones de 15 días',
    desc: 'No sirven si al volver tardás solo 2 horas en sentirte drenada otra vez.'
  }, {
    title: "Esperar que 'el resto cambie'",
    desc: 'Es entregar el control de tu felicidad a personas que no te cuidan.'
  }];
  return <Section data-id="element-128">
      <div className="text-center mb-16" data-id="element-129">
        <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-130">
          Por qué lo que intentaste{' '}
          <span className="text-red-400/80 italic" data-id="element-131">no funcionó</span>
        </h2>
        <div className="w-24 h-px bg-gold/50 mx-auto" data-id="element-132" />
      </div>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-133">
        {fallos.map((fallo, i) => <div key={i} className="flex gap-4 p-6 border border-red-900/30 bg-red-950/10 rounded-sm relative overflow-hidden group" data-id="element-134">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-900/50 group-hover:bg-red-500/50 transition-colors" data-id="element-135" />
            <div className="mt-1 text-red-400/80 shrink-0" data-id="element-136">
              <X size={24} data-id="element-137" />
            </div>
            <div data-id="element-138">
              <h3 className="text-lg font-medium text-offwhite mb-2 line-through decoration-red-900/50" data-id="element-139">
                {fallo.title}
              </h3>
              <p className="text-gray-400 font-light" data-id="element-140">{fallo.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
};